// Blog post registry for the /blog index page.
// Each post page is its own component for full content/SEO control.
// Order: case studies first, then thought-leadership / guides, then DMC basics.
export const BLOG_POSTS = [
  {
    slug: "case-study-1800-pax-dubai-corporate-conference",
    title: "How We Managed a 1,800-Pax Corporate Conference in Dubai",
    excerpt:
      "Behind the scenes of a 1,800-pax 5-day global sales conference operated across 11 Dubai hotels — the brief, the logistics challenge, the dynamic solutions, the ROI.",
    category: "Case Study",
    readTime: "8 min read",
    publishedISO: "2026-02-16",
    publishedLabel: "Feb 16, 2026",
    author: "Trawelldmc Team",
    image:
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?crop=entropy&cs=srgb&fm=webp&w=1600&q=80",
  },
  {
    slug: "case-study-singapore-360-pax-incentive-trip",
    title: "Case Study: 360-Pax Singapore Incentive Trip Delivered in 60 Days",
    excerpt:
      "How Trawelldmc operated a 360-pax 4-day Singapore incentive programme on a 60-day lead time — Marina Bay venues, F1 weekend overlap, and 100% retention rate.",
    category: "Case Study",
    readTime: "7 min read",
    publishedISO: "2026-02-17",
    publishedLabel: "Feb 17, 2026",
    author: "Trawelldmc Team",
    image:
      "https://images.unsplash.com/photo-1565967511849-76a60a516170?crop=entropy&cs=srgb&fm=webp&w=1600&q=80",
  },
  {
    slug: "case-study-bali-350-pax-channel-partner-launch",
    title: "Case Study: A 350-Pax Channel Partner Launch in Bali",
    excerpt:
      "Nusa Dua venues, a beachfront drone-light gala, content captured by a 6-person production team — and a 4× engagement uplift versus prior years.",
    category: "Case Study",
    readTime: "7 min read",
    publishedISO: "2026-02-17",
    publishedLabel: "Feb 17, 2026",
    author: "Trawelldmc Team",
    image:
      "https://images.unsplash.com/photo-1537996194471-e657df975ab4?crop=entropy&cs=srgb&fm=webp&w=1600&q=80",
  },
  {
    slug: "mice-asia-trends-2026",
    title: "MICE in Asia 2026: Seven Trends Every Corporate Planner Should Track",
    excerpt:
      "From AI-driven RFP processes and sustainability-linked KPIs to the rise of secondary Asian cities — the seven trends shaping Asian MICE in 2026.",
    category: "MICE Insight",
    readTime: "8 min read",
    publishedISO: "2026-02-17",
    publishedLabel: "Feb 17, 2026",
    author: "Trawelldmc Team",
    image:
      "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?crop=entropy&cs=srgb&fm=webp&w=1600&q=80",
  },
  {
    slug: "how-to-write-mice-rfp-asia",
    title: "How to Write a MICE RFP That Gets You the Best Asia Proposals",
    excerpt:
      "A practical guide for corporate MICE planners — the seven sections every Asia MICE RFP should contain, common mistakes to avoid, and a printable checklist.",
    category: "MICE Guide",
    readTime: "9 min read",
    publishedISO: "2026-02-17",
    publishedLabel: "Feb 17, 2026",
    author: "Trawelldmc Team",
    image:
      "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=webp&w=1600&q=80",
  },
  {
    slug: "what-is-a-destination-management-company",
    title: "What Is a Destination Management Company (DMC)?",
    excerpt:
      "A complete guide to what a DMC does, the services they provide, who uses them, and how to choose the right one for your corporate or group programme.",
    category: "DMC Basics",
    readTime: "6 min read",
    publishedISO: "2026-02-16",
    publishedLabel: "Feb 16, 2026",
    author: "Trawelldmc Team",
    image:
      "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=webp&w=1600&q=80",
  },
  {
    slug: "top-incentive-travel-destinations-southeast-asia",
    title: "Top 7 Incentive Travel Destinations in Southeast Asia",
    excerpt:
      "From Singapore's polished MICE hub to Bali's luxury villa retreats — the seven Southeast Asian destinations every incentive buyer should know.",
    category: "Incentive Travel",
    readTime: "7 min read",
    publishedISO: "2026-02-16",
    publishedLabel: "Feb 16, 2026",
    author: "Trawelldmc Team",
    image:
      "https://images.unsplash.com/photo-1604999333679-b86d54738315?crop=entropy&cs=srgb&fm=webp&w=1600&q=80",
  },
];
